import ErrorAlert from "@/utility/ErrorAlert";
import http from "@/axios/http-common";

const BASE = "/ppi/injection-audit";

// ==================== MASTER ====================
async function getItemDefinitions() {
  const response = await http.getData(`${BASE}/item-definitions`).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

// ==================== SESSIONS ====================
async function getList(params?: any) {
  const response = await http
    .getDataParam(`${BASE}/sessions`, params)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function find(id: number) {
  const response = await http.getData(`${BASE}/sessions/${id}`).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function create(data: any) {
  const response = await http.postData(`${BASE}/sessions`, data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function update(id: number, data: any) {
  const response = await http
    .putData(`${BASE}/sessions/${id}`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function destroy(id: number) {
  const response = await http.deleteData(`${BASE}/sessions/${id}`).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

// ==================== CHECKLIST ====================
async function upsertChecks(sessionId: number, checks: any[]) {
  const response = await http
    .postData(`${BASE}/sessions/${sessionId}/checks`, { checks })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

// ==================== SIGN (4-tier) ====================
async function submitAuditor(id: number, data: any) {
  const response = await http
    .postData(`${BASE}/sessions/${id}/submit-auditor`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function approveKaUnit(id: number, data: { password: string }) {
  const response = await http
    .postData(`${BASE}/sessions/${id}/approve-ka-unit`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function approveKaPpi(id: number, data: { password: string }) {
  const response = await http
    .postData(`${BASE}/sessions/${id}/approve-ka-ppi`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function approvePimpinan(id: number, data: { password: string }) {
  const response = await http
    .postData(`${BASE}/sessions/${id}/approve-pimpinan`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

// ==================== RTL ====================
async function autoGenerateRtl(sessionId: number) {
  const response = await http
    .postData(`${BASE}/sessions/${sessionId}/auto-generate-rtl`, {})
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function storeRtl(sessionId: number, data: any) {
  const response = await http
    .postData(`${BASE}/sessions/${sessionId}/rtl`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function updateRtl(sessionId: number, rtlId: number, data: any) {
  const response = await http
    .putData(`${BASE}/sessions/${sessionId}/rtl/${rtlId}`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function destroyRtl(sessionId: number, rtlId: number) {
  const response = await http
    .deleteData(`${BASE}/sessions/${sessionId}/rtl/${rtlId}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function getRtlTerbuka(params?: any) {
  const response = await http
    .getDataParam(`${BASE}/rtl-terbuka`, params)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

// ==================== ADVERSE EVENT ====================
async function storeAdverseEvent(sessionId: number, data: any) {
  const response = await http
    .postData(`${BASE}/sessions/${sessionId}/adverse-events`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function updateAdverseEvent(sessionId: number, aeId: number, data: any) {
  const response = await http
    .putData(`${BASE}/sessions/${sessionId}/adverse-events/${aeId}`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function destroyAdverseEvent(sessionId: number, aeId: number) {
  const response = await http
    .deleteData(`${BASE}/sessions/${sessionId}/adverse-events/${aeId}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

// ==================== DASHBOARD ====================
async function getDashboard(params?: any) {
  const response = await http
    .getDataParam(`${BASE}/dashboard`, params)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

// ==================== PDF ====================
function printPdf(id: number) {
  window.open(`${http.getAPI()}${BASE}/sessions/${id}/pdf`, "_blank");
}

export default {
  getItemDefinitions,
  getList,
  find,
  create,
  update,
  destroy,
  upsertChecks,
  submitAuditor,
  approveKaUnit,
  approveKaPpi,
  approvePimpinan,
  autoGenerateRtl,
  storeRtl,
  updateRtl,
  destroyRtl,
  getRtlTerbuka,
  storeAdverseEvent,
  updateAdverseEvent,
  destroyAdverseEvent,
  getDashboard,
  printPdf
};
